import React from "react";

import OfficialPartners from "../Components/OfficialPartners";
import Getmembershipposter from "../Components/Getmembershipposter";
import Sportsblog from "../Components/SportsBlog/Sportsblog";
import SportsGallery from "../Components/SportsGallery/SportsGallery";
import Highlights from "../Components/Highlights/Highlights";
import MatchScore from "../Components/MatchScore/MatchScore";
import BigMatchScore from "../Components/MatchScore/BigMatchScore";
import Sportsnews from "../Components/SportsNews/Sportsnews";
import SportsPlayersMain from "../Components/SportsPlayers/SportsPlayersMain";
import ShopMain from "../Components/Shop/ShopMain";
import ViewBanner from "../Components/ViewBanner";
import Homebanner from "../Components/Homebanner";
import { Helmet } from "react-helmet";
import BigMatchCard from "../Components/MatchScore/BigMatchCard";
import BigMatchHighlights from "../Components/Highlights/BigMatchHighlights";

function Homepage() {
  return (
    <>
     <Helmet>
        <meta charSet="utf-8" />
        <title>Home - St Johns College Jaffna | Latest Sports News, Scores & Highlights</title>
        <link rel="canonical" href="https://stjohns.microwe.net/" />

        {/* Meta Description */}
        <meta
          name="description"
          content="Stay updated with St Johns College Jaffna's latest sports news, live match scores, player stats, highlights, and exclusive membership offers. Join the leading sports community now!"
        />

        {/* SEO Keywords */}
        <meta
          name="keywords"
          content="St Johns College Jaffna, sports news, live scores, sports highlights, player stats, sports community, sports blog, sports membership, sports shop, official partners"
        />

        {/* Robots for Search Indexing */}
        <meta name="robots" content="index, follow" />

        {/* Open Graph for Social Media */}
        <meta property="og:title" content="St Johns College Jaffna - Your Gateway to Sports News and Updates" />
        <meta property="og:description" content="Explore St Johns College Jaffna for live sports news, match scores, player highlights, and exclusive membership offers." />
        <meta property="og:image" content="http://mysite.com/images/og-image.jpg" />
        <meta property="og:url" content="https://stjohns.microwe.net/" />
        <meta property="og:type" content="website" />

        {/* Twitter Card for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="St Johns College Jaffna | Sports News, Scores & Membership" />
        <meta name="twitter:description" content="Join St Johns College Jaffna to get live sports updates, match scores, and player highlights. Become a member today!" />
        <meta name="twitter:image" content="http://mysite.com/images/twitter-card.jpg" />

        {/* Local SEO (if applicable) */}
        <meta name="geo.region" content="LK" /> 
        <meta name="geo.placename" content="St Johns College Jaffna, Jaffna, Srilanka" /> 
        <meta name="geo.position" content="9.9252; 8.5240" />
        <meta name="ICBM" content="9.9252, 8.5240" />

 

       
      </Helmet>

      <div className="w-full   ">
        <Homebanner/>
      </div>

      <div>
        <BigMatchCard />
      </div>

      <div>
        <BigMatchHighlights />
      </div>

      <div>
        <BigMatchScore />
      </div>
    
      {/* <div>
        <MatchScore />
      </div> */}

      <div>
        <Highlights />
      </div>

      <div>
        <SportsPlayersMain />
      </div>
 
      <div>
        <Sportsnews />
      </div>

      <div className="">
        <ViewBanner />
      </div>

     

      {/*<div>*/}
      {/*  <Sportsblog />*/}
      {/*</div>*/}

      <div>
        <SportsGallery />
      </div>

      {/* <div>
        <ShopMain />
      </div> */}

	    {/* <div> */}
        {/* <Getmembershipposter />*/}
      {/* </div>*/}

      <div>
        <OfficialPartners />
      </div>
    </>
  );
}

export default Homepage;
